<template>
    <common-modal width="small" @close="emitEvent({ name: 'close' })">
        <common-content-spacer class="edit-price-modal" height="small">
            <common-page-header size="small" :heading="$t('common.microcopy.edit')" :isCenter="true"></common-page-header>
            <div>
                <span>
                    {{ $t('common.microcopy.current_price') }}
                </span>
                {{ offerPrice }}
            </div>
            <form-wrapper @form-submit="submit">
                <form-row>
                    <text-input
                        class="edit-price-modal--input"
                        :formData="data"
                        :label="`${$t('forms.offer.create_offer.fields.price.label')}`"
                        :placeholder="$t('forms.offer.create_offer.fields.price.placeholder')"
                        valuePath="price"
                        :isRequired="true"
                        type="number"
                        @change="change"
                    ></text-input>
                </form-row>
                <template #footer>
                    <common-content-spacer height="medium">
                        <common-buttons>
                            <common-button type="primary" :label="$t('common.microcopy.save')"></common-button>
                        </common-buttons>
                    </common-content-spacer>
                </template>
            </form-wrapper>
        </common-content-spacer>
    </common-modal>
</template>

<script>
    import FormMixin from 'mixins/FormMixin'
    import PriceMixin from 'mixins/PriceMixin'
    import CalendarEventAPI from 'api/CalendarEventAPI'

    export default {
        mixins: [FormMixin, PriceMixin],
        props: {
            offerPrice: { type: String, default: undefined },
        },
        methods: {
            submit() {
                const request = {
                    price: Number(this.data.price),
                    calendarEventId: Number(this.$route.params.id),
                }
                CalendarEventAPI.updateReservationPrice(request).then(() => {
                    this.$toast.success(this.$t('common.microcopy.success'))
                    this.emitEvent({ name: 'price-updated' })
                })
            },
        },
    }
</script>

<style lang="scss" scoped>
    .edit-price-modal {
        &--input {
            width: 100%;
        }
    }
</style>
